import React from 'react'
import {CampaignChannel, ChannelVariant} from '../../../types/campaigns'

interface ChannelTabsProps {
  channels: CampaignChannel[]
  activeChannel: CampaignChannel
  onChannelChange: (channel: CampaignChannel) => void
  variants: ChannelVariant[]
}

const CHANNEL_INFO = {
  SMS: {
    icon: '💬',
    label: 'SMS',
    color: 'primary',
  },
  EMAIL: {
    icon: '📧',
    label: 'Email',
    color: 'success',
  },
  WHATSAPP: {
    icon: '📱',
    label: 'WhatsApp',
    color: 'info',
  },
  TELEGRAM: {
    icon: '✈️',
    label: 'Telegram',
    color: 'warning',
  },
}

export const ChannelTabs: React.FC<ChannelTabsProps> = ({
  channels,
  activeChannel,
  onChannelChange,
  variants,
}) => {
  const hasVariant = (channel: CampaignChannel) => {
    return variants.some((v) => v.channel === channel)
  }

  return (
    <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6'>
      {channels.map((channel) => {
        const info = CHANNEL_INFO[channel]
        const variant = hasVariant(channel)
        const isActive = activeChannel === channel

        return (
          <li key={channel} className='nav-item'>
            <a
              className={`nav-link ${isActive ? 'active' : ''}`}
              onClick={() => onChannelChange(channel)}
              style={{cursor: 'pointer'}}
            >
              <span className='me-2'>{info.icon}</span>
              {info.label}
              {variant && (
                <span className='badge badge-light-success badge-circle ms-2'>
                  ✓
                </span>
              )}
              {!variant && (
                <span className='badge badge-light-secondary badge-circle ms-2'>
                  +
                </span>
              )}
            </a>
          </li>
        )
      })}
    </ul>
  )
}
